import CalendarService from './CalendarService';

export default {
	'services.calendarService': {
		class: CalendarService,
		deps: [{ $ref: 'services.APIService' }, { $ref: 'services.applicationService' }],
	},
};
